import { nextTick, ref, watch, getCurrentInstance } from '@vue/composition-api'
import { useElementSize } from '@vueuse/core'
import { useWindowResize } from '@ms/utils/listener'

export default () => {
  const { proxy: vm } = getCurrentInstance()
  const scrollMarginTop = ref(0)
  const content = ref(null)

  const contentRefSize = useElementSize(content)

  const updateScrollStyle = () => {
    nextTick(() => {
      const content = vm.$refs.content
      if (!content) return
      const { offsetHeight } = content
      const parentHeight = vm.$el.offsetHeight
      const maxHeight = parentHeight * 0.94

      const getScrollMarginTop = () => {
        if (vm.noMargin) return 0

        return offsetHeight !== parentHeight && offsetHeight > maxHeight ? Math.ceil(offsetHeight - maxHeight) : 0
      }

      scrollMarginTop.value = getScrollMarginTop()
    })
  }

  watch(contentRefSize.height, () => {
    updateScrollStyle()
  })

  watch(
    () => vm.visible,
    (visible) => {
      visible ? updateScrollStyle() : (scrollMarginTop.value = 0)
    }
  )

  useWindowResize(updateScrollStyle)

  return { scrollMarginTop, updateScrollStyle, content }
}
